var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.displayRecording
    ? _c("div", [
        _c(
          "a",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPlayButton,
                expression: "showPlayButton"
              },
              {
                name: "tooltip",
                rawName: "v-tooltip.left",
                value: "Play",
                expression: "'Play'",
                modifiers: { left: true }
              }
            ],
            staticClass: "recording-cell__btn",
            attrs: {
              href: "javascript:;",
              "data-testid": "v2-reporting-recording-cell-play-btn"
            },
            on: { click: _vm.showAudioPlayer }
          },
          [_c("i", { staticClass: "fa fa-play" })]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showPlayButton,
                expression: "!showPlayButton"
              },
              {
                name: "tooltip",
                rawName: "v-tooltip.left",
                value: "Stop",
                expression: "'Stop'",
                modifiers: { left: true }
              }
            ],
            staticClass: "recording-cell__btn",
            attrs: {
              href: "javascript:;",
              "data-testid": "v2-reporting-recording-cell-stop-btn"
            },
            on: { click: _vm.stopAudioPlayer }
          },
          [_c("i", { staticClass: "red fa fa-stop" })]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }